import { render, staticRenderFns } from "./UrbanismRegulationsListFilter.vue?vue&type=template&id=835dfd76&scoped=true&"
import script from "./UrbanismRegulationsListFilter.vue?vue&type=script&lang=js&"
export * from "./UrbanismRegulationsListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835dfd76",
  null
  
)

export default component.exports